import { render, staticRenderFns } from "./NoSpendSearch.vue?vue&type=template&id=131f4181&"
import script from "./NoSpendSearch.vue?vue&type=script&lang=js&"
export * from "./NoSpendSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports